export type UserAgreementNode =
  | { type: 'br' }
  | { type: 'h1' | 'h2' | 'h3' | 'p' | 'strong'; text: string };

export const userAgreementNodes: UserAgreementNode[] = [
  {
    "type": "h1",
    "text": "圆领平台用户协议"
  },
  {
    "type": "p",
    "text": "（2024年04月01日版本）"
  },
  {
    "type": "p",
    "text": "（2024年04月08日生效）"
  },
  {
    "type": "p",
    "text": "欢迎访问圆领平台（以下简称“本平台”或“我们”）并使用我们提供的产品和服务。本平台的权利人是上海魔法向量网络有限公司（以下简称“魔法向量”）。"
  },
  {
    "type": "p",
    "text": "圆领平台系为相关企业或其他主体（以下简称“服务接受方”）和个人（以下简称“服务提供方”）提供的一个服务交易平台，并根据服务接受方提出的所需服务的特定需求筛选、推荐符合要求的服务提供方，并由服务提供方向服务接受方提供相关服务。服务接受方与服务提供方，均属于圆领平台的用户（以下合称“用户”）。      "
  },
  {
    "type": "p",
    "text": "本协议是用户与魔法向量之间就使用魔法向量旗下圆领网站即www.yuanling.com及相关的应用程序包括但不限于圆领、圆领卖家版等相关的应用程序等相关事宜所订立的契约，请用户在使用圆领网站或应用程序相关服务之前认真阅读本协议全部内容。用户在使用系统之前，务必仔细阅读并透彻理解本圆领平台用户协议（以下简称“本协议”），在确认充分理解后选择接受或不接受本协议；一旦用户通过网页点击“同意”或开始使用本平台服务，即表明用户已阅读并同意本协议条款的约束。如用户不同意本协议条款或其中任何条款的约定，请勿使用本平台服务或通过其他方式获取服务。"
  },
  {
    "type": "p",
    "text": "用户应当在系统功能要求时向本平台提供个人姓名、基本信息或企业机构的名称和证照如营业执照等；用户在本平台的使用操作行为均视为其本人或本企业机构的行为。"
  },
  {
    "type": "h2",
    "text": "1 通则"
  },
  {
    "type": "p",
    "text": "1.1 本平台提供多种在线服务交易形式，包括但不限于："
  },
  {
    "type": "p",
    "text": "1.1.1 服务接受方通过圆领平台提出服务需求，服务提供方通过圆领平台向服务接受方提供符合其需求的服务。"
  },
  {
    "type": "p",
    "text": "1.1.2 服务提供方将自己的技能包装为在线服务型商品，服务接受方通过浏览网站、PC应用或者移动应用来沟通买替服务提供方的商品。"
  },
  {
    "type": "p",
    "text": "1.2 用户所有的经营行为均应具有相应的资质。用户必须遵守国家有关法律、法规、规章及其他规范性文件，包括但不限于《中华人民共和国网络安全法》、《中华人民共和国电信条例》、《互联网信息服务管理办法》等，不得从事任何违法经营活动，负责自身的网络信息安全并有能力承担入网后的信息安全责任。"
  },
  {
    "type": "p",
    "text": "1.3 本协议所指的“产品和服务”是指本平台上所展示的服务提供方所提供的各类服务等，部分产品和服务将收取一定的费用，具体服务内容可见本平台相关页面的介绍。"
  },
  {
    "type": "p",
    "text": "1.4 本协议所指的“卖家”包括商品拥有者、项目制订单组队时的队员服务者、平台自营类商品的个人服务商等所有服务买方的注册卖家。"
  },
  {
    "type": "h2",
    "text": "2 本站用户协议的生效与变更"
  },
  {
    "type": "p",
    "text": "2.1 本协议内容包括协议正文及各类相关规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。除另行明确声明外，任何魔法向量及其关联公司提供的服务（以下简称为“平台服务”）均受本协议约束。"
  },
  {
    "type": "p",
    "text": "2.2 用户使用平台服务，则本协议可由本平台不定期地制订、修改本协议和/或各类规则，并在圆领网站www.yuanling.com或圆领、圆领卖家等相关应用程序上公示，并以网页公告、站内信或电子邮件等方式的方式告知用户更新的内容，若用户不同意修改可通过注销账号解除本条款；若公告期（7日）满后用户继续使用的，视为接受更新。用户可在本平台内【首页底部】-【协议与规则】-【平台用户协议】或APP内【我的】-【设置】-【平台用户协议】查阅最新版用户协议。除非用户在新协议生效前已经享有的事项，否则用户的权利及义务、购买相关程序及收费标准均以最新的用户协议中各条款和购买页面展示为准。"
  },
  {
    "type": "p",
    "text": "2.3 本协议条款是处理各方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的除外。用户承诺接受并遵守本协议的约定。如果用户不同意本协议的约定，用户应立即停止注册程序或停止使用圆领网站或应用程序。"
  },
  {
    "type": "h2",
    "text": "3 用户账户注册、使用与安全"
  },
  {
    "type": "p",
    "text": "3.1 用户注册的资格"
  },
  {
    "type": "p",
    "text": "1) 用户确认，在完成注册程序或以其他圆领平台允许的方式实际使用本服务时，用户应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他机构、组织，能够独立承担法律责任。"
  },
  {
    "type": "p",
    "text": "2) 若用户是未成年人或限制民事行为能力人，则不具备前述主体资格，其监护人应承担因其的不当注册行为而导致的一切后果。"
  },
  {
    "type": "p",
    "text": "3) 用户还需确保其不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则用户可能无法正常注册及使用圆领平台服务。"
  },
  {
    "type": "p",
    "text": "3.2 账户注册"
  },
  {
    "type": "p",
    "text": "1) 当用户按照注册页面提示填写信息、阅读并同意本服务条款且完成全部注册程序后，可获得圆领平台账户并成为圆领的注册用户。"
  },
  {
    "type": "p",
    "text": "2) 用户在注册时候设置或确认的账户名（“账户名称”）及您设置的密码，将在注册成功后成为用户的账户（账户名称及密码合称“账户”）。"
  },
  {
    "type": "p",
    "text": "3) 用户设置的账户名称不得违反国家法律法规、圆领的管理规范或容易引起用户与圆领身份的混淆，否则用户的账户可能不能注册成功或圆领平台有权经通知用户后予以注销。"
  },
  {
    "type": "p",
    "text": "5) 圆领平台可能会就某些产品或服务的开通，要求用户提供更多的身份资料和信息，做进一步的身份认证或资格验证，用户的账户只有在通过这些认证和验证之后，方可获得使用相关产品或服务的资格。"
  },
  {
    "type": "p",
    "text": "6) 通常情况下，用户的圆领平台账户是用户在圆领平台进行一切活动的唯一身份标识，除非另有约定，每一个圆领账户都可以在本网站独立开展活动。但在下列情形下，圆领平台有权根据自己的判断，对同一及/或关联法律主体拥有的多个圆领账户进行统一处理，如根据不同圆领账户在注册、登录、使用中的关联信息，圆领平台判断其实际为同一用户。就同一用户的关联信息举例：同一证件、同一手机号、同一支付账号、同一设备、同一地址等。"
  },
  {
    "type": "p",
    "text": "3.3 账户的使用与安全"
  },
  {
    "type": "p",
    "text": "1) 用户有权使用其设定的账户登录圆领平台，进而使用圆领提供的其他服务。"
  },
  {
    "type": "p",
    "text": "2) 圆领平台可能会以邮件、站内信、短信或电话等方式通知用户服务进展情况以及提示用户进行下一步的操作。在服务过程中用户应当及时登录到圆领账户查看和进行交易操作。"
  },
  {
    "type": "p",
    "text": "3) 一个圆领账户仅能对应唯一的法律主体。除非有法律明文规定、司法裁定或者经圆领平台同意的情况下，用户不得以任何方式转让、赠与或让他人继承用户的圆领账户。"
  },
  {
    "type": "p",
    "text": "4) 用户需要对自己的账户进行妥善保管，且仅供用户自己使用。用户应当对其名下所有的账户的一切行为承担责任，包括但不限于账户所实施的违法行为等。未经法律规定、有权机关命令或本平台的允许，用户不得将账户交由第三方控制和使用，因擅自交由第三方导致的损失，由用户及第三方自行承担，若导致本平台受到损失的，本平台有权要求用户和第三方承担连带责任。"
  },
  {
    "type": "p",
    "text": "5) 用户的账户和密码由用户自行设置并由其保管，用户须对其圆领平台账户和密码保密。用户需确保在每个上网时段结束时，以正确步骤退出。"
  },
  {
    "type": "p",
    "text": "7) 圆领平台亦会在网站服务端采取合理的技术措施保障账户的安全。"
  },
  {
    "type": "h2",
    "text": "4 账户的冻结、注销及申诉"
  },
  {
    "type": "p",
    "text": "4.1 账户的冻结 用户的圆领平台账户（全部或部分权限或功能）在如下情况可能被冻结（如圆领平台账户被限制资金转出功能等），圆领平台将通过邮件、站内信、短信或电话等方式通知用户："
  },
  {
    "type": "p",
    "text": "1) 基于圆领平台或服务运行和交易安全的需要，如用户发生或可能发生破坏或试图破坏圆领平台或圆领关联公司公平交易环境或正常交易秩序的，或任何使用含有圆领或圆领关联公司名称、品牌、标记、Logo且对他人有误导嫌疑或任何使用某种中英文(全称或简称)、数字、域名等意图表示或映射与圆领或其关联公司具有某种关联的；"
  },
  {
    "type": "p",
    "text": "2) 违反本用户协议、圆领平台的相关规则、规范（如交易规则、管理规范）、服务说明以及其他服务协议/条款的；"
  },
  {
    "type": "p",
    "text": "3) 违反国家法律、法规、政策、法律文书的规定的；"
  },
  {
    "type": "p",
    "text": "4) 您遭到他人投诉，且对方已经提供了相关证据的，而用户未按照本平台的要求提供相反证据的；"
  },
  {
    "type": "p",
    "text": "5) 圆领平台根据合理分析判断用户的账户操作、收益存在异常的；"
  },
  {
    "type": "p",
    "text": "6) 国家机关要求进行的冻结的；"
  },
  {
    "type": "p",
    "text": "7) 有包括但不限于引导线下交易、飞单、逃单、转包等有损卖家和平台根本性利益行为的；"
  },
  {
    "type": "p",
    "text": "8) 圆领平台合理判断，用户发生与如上行为性质相同或产生如上类似风险的其他情况的。"
  },
  {
    "type": "p",
    "text": "4.2 账户的强制注销"
  },
  {
    "type": "p",
    "text": "1) 如果出现如上第4.1条情形且情形严重的，或基于国家机关的要求，用户的圆领平台账户（全部或部分权限或功能）将被注销，圆领平台将通过邮件、站内信、短信或电话等方式通知您。"
  },
  {
    "type": "p",
    "text": "2) 用户理解并同意，如连续12个月未通过账户登录过圆领平台，且用户的账户下不存在任何未到期的服务或充值卡余额，圆领平台有权注销用户的账户，用户将不能再登录圆领平台。"
  },
  {
    "type": "p",
    "text": "3) 用户设置的用户名不得侵犯或涉嫌侵犯他人合法权益。否则，本平台有权终止向用户提供服务，并注销用户的账户。账户注销后，相应的用户名将开放给任意用户注册登记使用。"
  },
  {
    "type": "p",
    "text": "4.3 申诉"
  },
  {
    "type": "p",
    "text": "1) 发生前述账户冻结或注销情况下，用户应及时予以关注并可以按照程序进行申诉等后续操作： 用户通过申诉程序，向圆领平台申请解除上述冻结或注销的，为了用户的账户安全，用户应配合如实提供身份证明及相关资料，以及圆领平台要求的其他信息或文件，以便圆领进行核实。用户应充分理解申诉并不必然被接受，圆领有权依据合理判断及相关信息决定是否同意申诉请求。"
  },
  {
    "type": "p",
    "text": "2) 用户理解并同意，如果用户拒绝如实提供身份证明及相关资料，或未能通过圆领平台审核，圆领有权长期冻结该等账户且长期限制账户部分或全部功能。"
  },
  {
    "type": "h2",
    "text": "5 平台用户违规行为定义"
  },
  {
    "type": "p",
    "text": "圆领平台切实的帮助了很多卖家实现了地点自由的生活，为了让幸福的故事永远发生下去，平台用户必须清晰的认识到，任意程度的违规对其他兢兢业业的卖家和平台来说都是极大的伤害。以下行为被视为平台红线，一经发现，严肃处理。"
  },
  {
    "type": "p",
    "text": "5.1 卖家用户在购买咨询阶段未深入沟通就向买家索要其他联系方式的。"
  },
  {
    "type": "p",
    "text": "5.2 买家用户在购买咨询阶段未深入沟通就向卖家索要其他联系方式的。"
  },
  {
    "type": "p",
    "text": "5.3 买卖双方通过平台下单，后又取消订单脱离平台进行交易的。"
  },
  {
    "type": "p",
    "text": "5.4 买卖双方通过平台接触和认识，之后交易未发生在平台上的。"
  },
  {
    "type": "p",
    "text": "5.5 卖家套用他人身份证信息注册账号为自己接单的；卖家注册时提供不实身份信息的；多个卖家账号经调查实际为同个联系人的；卖家用户接到订单后的服务，包括订单结束后的后续服务，转包给他人，非自身提供服务的。"
  },
  {
    "type": "p",
    "text": "5.6 卖家服务量已饱和，或无时间提供服务，但未及时暂停服务并导致咨询转换率过低的。"
  },
  {
    "type": "p",
    "text": "5.7 卖家商品低价引流成交订单后，后续大金额订单未在平台上发生的。"
  },
  {
    "type": "p",
    "text": "5.8 卖家在开启服务后，未事先通知，导致买家联系不上持续2天的。"
  },
  {
    "type": "p",
    "text": "5.9 卖家以平台收取服务费为理由向买家要求涨价或者额外支付费用的。"
  },
  {
    "type": "p",
    "text": "5.10 买家用户来平台挖人、宣传其他接单渠道或平台的。"
  },
  {
    "type": "p",
    "text": "5.11 卖家用户来平台挖单、导流的。"
  },
  {
    "type": "p",
    "text": "5.12 买家用户与卖家在平台接触后，任何一方诱导交易走非平台渠道的；或双方通过平台有过交易，后续任何一方诱导交易走非平台渠道的。"
  },
  {
    "type": "p",
    "text": "5.13 卖家为2人及以上的服务室/机构/企业/营业性组织的（单人服务室除外），此条用于保障买家享受到的就是所购买商品的卖家本人的服务。"
  },
  {
    "type": "p",
    "text": "5.14 卖家泄露买方数据资料的。"
  },
  {
    "type": "p",
    "text": "5.15 买家与平台认识的卖家脱离平台私下签订其他用工合同并未缴纳买断费用的。"
  },
  {
    "type": "p",
    "text": "5.16 买家与平台认识的卖家（包含经平台认识的非平台卖家，如平台卖家转介绍的其他人才）脱离平台交易的。"
  },
  {
    "type": "p",
    "text": "5.17 以上规定一旦违反，平台会从实际情况出发，情节较轻并认错态度良好的，处以与基础保证金或所逃金额的9%（取其高者）同额的罚款，在罚款缴纳前，平台将冻结用户账户出账直至缴纳。飞单、逃单、私下转账、私下红包、注册身份信息不实、转包以及泄露客户重要数据均属于情节恶劣情形，证据确凿的平台将对买/卖家追缴所逃服务费（如有）、扣除相关违规账户的保证金和账户余额，并作永久封号处理。如违规行为属于5.9~5.16所定义的情形，平台会保留证据，走法律途径维护自身合法权益。对于以上任意违规行为所导致的资金损失平台不负任何责任。"
  },
  {
    "type": "p",
    "text": "5.18 买家与大量平台卖家建立了沟通(大于15人)却始终没有任何订单成交的，在平台调查后确系无其他红线违规的，平台有权对买家做出封号处理、谢绝其继续使用平台功能，其账户余额（如有）将会被退回。"
  },
  {
    "type": "p",
    "text": "5.19 平台对卖家的违规治理采取“可疑从有”的策略，即一旦发现卖家可疑，则需要卖家提供证据证明自己没有违规，任何聊天上下文缺失、断开或者不能提供的解释平台均不予以接受，均会被判定为对应违规。"
  },
  {
    "type": "h2",
    "text": "6 卖家用户保证金协议"
  },
  {
    "type": "p",
    "text": "为了保护平台买家的合法权益，以及保证平台所发生服务的交付质量，平台决定设立保证金机制。旨在规范卖家在平台上的经营行为，并明确保证金的缴纳、扣除和提取等相关事项。"
  },
  {
    "type": "p",
    "text": "6.1 保证金缴纳"
  },
  {
    "type": "p",
    "text": "6.1.1 保证金是否强制缴纳请参考最新的站内信通知公告。不同业务场景下所需要的保证金会有所不同，最终解释权归平台所有。平台有权对有过劣迹行为的卖家增收更高的保证金。"
  },
  {
    "type": "p",
    "text": "6.1.2 保证金金额根据卖家的历史经营情况进行评估，并由平台向卖家提供明确的缴纳指引和支付方式。具体的保证金缴纳金额计算规则以平台所发布的最新的站内信通知公告为准。"
  },
  {
    "type": "p",
    "text": "6.1.3 缴纳保证金的时间和方式应符合平台规定，并确保款项的及时到账和确认。否则平台有权对应缴纳但未缴纳的卖家进行处罚，处罚措施包括但不限于减少曝光、下架商品甚至取消超级个体资格等。"
  },
  {
    "type": "p",
    "text": "6.1.4 所有业务场景中所需缴纳的最低保证金称之为基础保证金。基础保证金的具体金额请参考最新的站内信通知公告或平台指定的其他相关协议。"
  },
  {
    "type": "p",
    "text": "6.2 违规行为和保证金扣除"
  },
  {
    "type": "p",
    "text": "6.2.1 卖家在平台上经营过程中，如被发现红线违规行为（协议第5部分所定义的），平台有权扣除卖家的保证金作为违规行为的处罚。"
  },
  {
    "type": "p",
    "text": "6.2.2 保证金的扣除不可逆转，如有异议可以提供充分有效的证明资料，并通过法律途径举证，最终以司法结果为准。"
  },
  {
    "type": "p",
    "text": "6.2.3 在严重违规的情况下，平台有权采取进一步的行动，包括但不限于永久封禁卖家的账号，以维护平台的秩序和平台买卖家用户的权益。"
  },
  {
    "type": "p",
    "text": "6.3 保证金提取"
  },
  {
    "type": "p",
    "text": "6.3.1 若卖家没有任何违规行为，可以随时联系客服申请提取其保证金。"
  },
  {
    "type": "p",
    "text": "6.3.2 提取保证金的申请应符合平台规定的程序，并提交必要的验证和确认文件。"
  },
  {
    "type": "p",
    "text": "6.3.3 平台将在收到申请后尽快审核并办理保证金的提取手续，确保卖家的合法权益。"
  },
  {
    "type": "p",
    "text": "6.4 保证金和经营限制"
  },
  {
    "type": "p",
    "text": "6.4.1 一旦平台要求卖家缴纳保证金（一对一或公告通知后），未缴纳保证金时卖家账号将不可营业，因此所有商品将均处于下架状态。当保证金缴纳完成后，方可恢复正常经营。"
  },
  {
    "type": "p",
    "text": "6.4.2 一旦缴纳保证金后，提取保证金将触发相应的权益下降，具体的规则可以参考各项权益说明或者咨询客服获取。一旦保证金归零，意味着账号将停止使用，将无法开展经营。"
  },
  {
    "type": "p",
    "text": "6.5 保证金规则调整协议"
  },
  {
    "type": "p",
    "text": "6.5.1 平台有权根据需要不时地制定、修改本协议，并以网站公示的方式进行公告，不再单独通知您。变更后的协议和规则一经在平台网站公布后，立即自动生效。如您不同意相关变更，应当立即停止店铺经营活动。您继续进行任何经营活动，包括但不限于修改商品信息、发布新商品、使用IM与客户进行沟通等等，即表示您接受经修订的协议。"
  },
  {
    "type": "p",
    "text": "6.5.2 保证金的具体上线时间将由平台公告决定，公告之日即保证金机制生效之时。"
  },
  {
    "type": "p",
    "text": "6.6 保证金上线日往前的历史违规行为处理方法"
  },
  {
    "type": "p",
    "text": "6.6.1 保证金上线之日往前的历史的第5部分所定义的用户违规行为一旦发现，将先需要缴纳与当前保证金相当的罚款金额才可以继续经营。例如，发现之时的平台基础保证金要求为1000元，那么用户需要另缴纳1000元的罚款才可以继续经营。"
  },
  {
    "type": "p",
    "text": "6.6.2 历史违规永不过期，但历史违规已被处罚过的，再次发现新的历史的（保证金上线之日往前）违规，不再进行二次罚款。"
  },
  {
    "type": "p",
    "text": "6.6.3 保证金上线日往前的历史违规行为在尚未被发现前如能自我检举的，可以免除罚款。"
  },
  {
    "type": "h2",
    "text": "7 用户发布内容规范"
  },
  {
    "type": "p",
    "text": "7.1 本条所述内容是指用户使用本平台服务的过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用账号或本服务所产生的内容。"
  },
  {
    "type": "p",
    "text": "7.2 用户不得利用“圆领”账号或通过本平台服务制作、上传、复制、发布、传播如下法律、法规和政策禁止的内容："
  },
  {
    "type": "p",
    "text": "1) 反对宪法所确定的基本原则的；"
  },
  {
    "type": "p",
    "text": "2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；"
  },
  {
    "type": "p",
    "text": "3) 损害国家荣誉和利益的；"
  },
  {
    "type": "p",
    "text": "4) 煽动民族仇恨、民族歧视，破坏民族团结的；"
  },
  {
    "type": "p",
    "text": "5) 破坏国家宗教政策，宣扬邪教和封建迷信的；"
  },
  {
    "type": "p",
    "text": "6) 散布谣言，扰乱社会公共秩序，包括但不限于破坏网络安全、妨害互联网秩序，破坏社会稳定的；"
  },
  {
    "type": "p",
    "text": "7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；"
  },
  {
    "type": "p",
    "text": "8) 侮辱或者诽谤他人，侵害他人合法权益的；"
  },
  {
    "type": "p",
    "text": "9) 违背伦理道德和公序良俗的；"
  },
  {
    "type": "p",
    "text": "10) 含有法律、行政法规禁止的其他内容的信息。"
  },
  {
    "type": "p",
    "text": "7.3 用户不得利用“圆领”账号或本平台服务制作、上传、复制、发布、传播如下干扰“圆领”平台正常运营，以及侵犯其他用户或第三方合法权益的内容："
  },
  {
    "type": "p",
    "text": "1) 含有任何性或性暗示的；"
  },
  {
    "type": "p",
    "text": "2) 含有辱骂、恐吓、威胁内容的；"
  },
  {
    "type": "p",
    "text": "3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的；"
  },
  {
    "type": "p",
    "text": "4) 涉及他人隐私、个人信息或资料的；"
  },
  {
    "type": "p",
    "text": "5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；"
  },
  {
    "type": "p",
    "text": "6) 含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。"
  },
  {
    "type": "p",
    "text": "7.4 如本平台自行发现或根据主管部门的信息、权利人的投诉等发现，用户违反相关法律法规、规章制度或本协议的，本平台有权要求用户删除、修改相关内容。本平台亦可采用直接删除、屏蔽、修改等方式处理相关内容，且/或对用户的平台账户采取限制、停用等操作。情节严重的，本平台有权终止协议并采取相关措施（包括但不限于终止向用户提供服务等），并依法追究用户的违约责任"
  },
  {
    "type": "h2",
    "text": "8 商品信息"
  },
  {
    "type": "p",
    "text": "圆领平台或相关的应用程序的商品价格、数量、是否有货等商品信息随时都有可能发生变动，不作特别通知。由于圆领的商品信息的数量庞大，虽然本平台会尽最大努力保证用户所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，显示的信息可能会有一定的滞后性或差错，对此情形用户已知悉并理解。"
  },
  {
    "type": "h2",
    "text": "9 服务费用"
  },
  {
    "type": "p",
    "text": "9.1 平台对买家不收取任何服务费用，对卖家收取少量的平台服务费，具体说明和解释参考《圆领平台交易规则》第二部分第4节。"
  },
  {
    "type": "h2",
    "text": "10 知识产权"
  },
  {
    "type": "p",
    "text": "10.1 用户一旦接受本协议，即表明该用户主动将其在任何时间段在圆领平台或应用程序发布的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地授权给魔法向量免费使用，不受时间、地域和使用方式的限制。用户同意魔法向量有权就任何主体未经许可使用前述信息内容的侵权行为而单独提起诉讼。"
  },
  {
    "type": "p",
    "text": "10.2 本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利授权之书面协议，其效力及于用户在圆领网站或应用程序上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。"
  },
  {
    "type": "p",
    "text": "10.3 用户同意并已充分了解本协议的条款，承诺不将已发布于本平台的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、应用程序、媒体上使用）。"
  },
  {
    "type": "p",
    "text": "10.4 除法律另有强制性规定外，未经魔法向量明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用圆领网站与应用程序的信息内容，否则，魔法向量有权追究其法律责任。"
  },
  {
    "type": "p",
    "text": "10.5 圆领网站与应用程序所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是魔法向量、瓴里或其内容提供者的财产，受中国和国际版权法的保护。本站或应用程序所有内容的汇编是魔法向量或瓴里的排他财产，受中国和国际版权法的保护。本站上所有软件都是魔法向量、瓴里或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。"
  },
  {
    "type": "p",
    "text": "10.6 用户应确保其在使用本平台产品和服务时，不得侵犯他人的知识产权。由于用户的行为导致的法律纠纷由用户自行承担责任，本平台不承担任何责任。"
  },
  {
    "type": "p",
    "text": "10.7 服务提供方应确保其向服务接受方提供服务时，不得侵犯他人的知识产权。未经服务接受方事先同意，服务提供方不得将其提供的服务、服务成果向任何第三方披露、复制、转让、授权其使用。"
  },
  {
    "type": "h2",
    "text": "11 保密义务"
  },
  {
    "type": "p",
    "text": "11.1 本平台在未经用户的事先书面同意的情况下，不会向其他任何主体提供、披露用户本平台所填写、提交的任何信息、资料、文件等，并将采用技术手段保障相关数据的安全。"
  },
  {
    "type": "p",
    "text": "11.2 在本协议履行中所涉及各方的产品、技术、财务、规划等信息应予以保密，并严格限制接触上述保密信息的员工遵守本条之保密义务。除非国家机关依法授权、强制要求或上述保密资料已经进入公有领域外，接受保密资料的一方不得对外披露。"
  },
  {
    "type": "p",
    "text": "11.3 各方应尽最大的努力保护上述保密信息等不被披露。一旦发现有上述保密信息泄露事件，各方应合作采取一切合理措施避免或者减轻损害后果的产生。"
  },
  {
    "type": "h2",
    "text": "12 平台用户积极举报、接受审查的义务"
  },
  {
    "type": "p",
    "text": "12.1 平台用户有义务对违规行为（协议第5条所定义的）进行检举揭发的义务。"
  },
  {
    "type": "p",
    "text": "12.2 如经平台审查发现纵容、包庇违规行为的，平台将视严重程度对用户实行宣导教育、吊销账号或永久封号等措施。"
  },
  {
    "type": "p",
    "text": "12.3 任何用户有履行配合平台人员进行违规审查的义务，拒不配合的，视作红线违规，平台有权进行永久封号处理。"
  },
  {
    "type": "h2",
    "text": "13 协议的终止"
  },
  {
    "type": "p",
    "text": "13.1 用户同意，魔法向量有权自行全权决定以任何理由不经事先通知的终止、终止向用户提供部分或全部圆领平台服务，暂时冻结或注销用户的账户，且无须为此向用户或任何第三方承担任何责任。"
  },
  {
    "type": "p",
    "text": "13.2 经双方一致同意终止协议，本协议终止。"
  },
  {
    "type": "p",
    "text": "13.3 任何一方均有权在以下情形之一出现时终止本协议："
  },
  {
    "type": "p",
    "text": "1) 另一方严重违反其在本协议项下的义务，且在收到守约方的书面违约通知后五（5）个工作日内未纠正该等违约行为。"
  },
  {
    "type": "p",
    "text": "2) 另一方被指定了接管人、破产管理人或类似人员负责另一方的任何或全部财产，或另一方寻求任何破产、接管、债权人安排，或另一方被提起类似程序或诉讼，并且在九十（90）日内未予撤销的，或者另一方无力偿还债务，或者在无继受人的情况下解散、清算或以其他方式无法正常经营。"
  },
  {
    "type": "p",
    "text": "13.4 出现以下情况时，魔法向量有权直接以注销用户账户的方式终止本协议:"
  },
  {
    "type": "p",
    "text": "1) 用户注册信息中的主要内容不真实或不准确或不及时或不完整；"
  },
  {
    "type": "p",
    "text": "2) 本协议（含平台规则）变更时，用户明示并通知魔法向量不愿接受新的服务协议的；"
  },
  {
    "type": "p",
    "text": "3) 圆领终止向用户提供服务后，用户涉嫌再一次直接或间接或以他人名义注册为圆领用户的；"
  },
  {
    "type": "p",
    "text": "13.5 用户有权向魔法向量要求注销用户的平台账户，经魔法向量审核同意的，圆领注销用户的平台账户；届时，用户与魔法向量基于本协议的合同关系即终止。用户的平台账户被注销后，魔法向量没有义务为用户保留或向用户披露用户账户中的任何信息，也没有义务向用户或第三方转发任何用户未曾阅读或发送过的信息。"
  },
  {
    "type": "p",
    "text": "13.6 用户同意，用户与本平台的合同关系终止后，本平台仍享有下列权利："
  },
  {
    "type": "p",
    "text": "1) 继续保存用户的注册信息及用户使用圆领网站与应用程序服务期间的所有交易信息，除非法律另有规定。"
  },
  {
    "type": "p",
    "text": "2) 平台用户在使用本平台各项产品服务期间存在违法行为或违反本协议和/或规则的行为的，本平台仍可依据本协议向平台用户主张权利。"
  },
  {
    "type": "p",
    "text": "13.7 本协议终止后，用户在圆领平台账户内的优惠券等平台虚拟资产（若有）同时作废。"
  },
  {
    "type": "h2",
    "text": "14 免责事项"
  },
  {
    "type": "p",
    "text": "14.1 用户已理解并同意，本平台向用户提供服务的前提条件为用户所提供、填写、提交的所有材料、信息、文件等皆为真实、准确、合法的，本平台仅在用户所提供的信息基础上按照适用现行有效的相关法律法规、国家标准向用户提供平台服务，本平台不对筛选服务结果的准确性、真实性做任何形式的承诺与保证，用户需对因使用本平台服务所作出的决策产生的相应结果承担相应责任。"
  },
  {
    "type": "p",
    "text": "14.2 用户已知悉并同意，用户所进行的一切操作均为用户真实意愿的表达并具备法律效力，因用户的误操作所造成的一切后果本平台会在收到用户反馈的第一时间进行协助，但不承担一切责任。同时就下列相关事宜的发生，本平台亦不承担任何法律责任："
  },
  {
    "type": "p",
    "text": "1) 由于用户提供的信息有误；"
  },
  {
    "type": "p",
    "text": "2) 由于用户自身行为造成的信息泄露或因第三方的骗取等手段造成的泄露；"
  },
  {
    "type": "p",
    "text": "3) 由于用户将用户密码告知他人或与他人共享注册帐户，由此导致的任何信息的泄漏，或其他非因本平台原因导致的信息的泄漏；"
  },
  {
    "type": "p",
    "text": "4) 本平台在各服务条款及法律声明中列明的其他免责情形。"
  },
  {
    "type": "p",
    "text": "14.3 如用户利用本平台的服务给其他用户或第三方的利益造成损害，所有责任由该用户自行承担，本平台不承担任何责任；对于用户因各种条件无法接受本平台提供的服务时，给其他用户或第三方带来的损失，魔法向量不承担任何责任。"
  },
  {
    "type": "p",
    "text": "14.4 本平台刊载的各类文章、广告、用户在本平台发表的观点以及以链接形式推荐的其他网站内容，仅为提供更多信息以参考使用或者学习交流，并不代表本平台的立场和观点。"
  },
  {
    "type": "p",
    "text": "14.5 由于法律规定的不可抗力，信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，黑客攻击，电力故障，劳动争议，生产力或生产资料不足，司法行政机关的命令或第三方的不作为及其他本公司无法控制的原因造成的圆领网站或应用程序不能服务或延迟服务、丢失数据信息、记录的，本平台不承担责任，但将在法律、法规允许的范围内协助处理相关事宜。"
  },
  {
    "type": "p",
    "text": "14.6 本协议所称之不可抗力是指不能预见、不能避免且不能克服的客观情况，包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、传染病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其他自然或人为造成的灾难等客观情况"
  },
  {
    "type": "p",
    "text": "14.7 除本协议注明的服务条款外，其他一切因使用圆领网站或应用程序而引致的任何意外、疏忽、诽谤、版权或知识产权侵犯及其所造成的损失（包括因下载而感染电脑病毒），本平台不承担任何法律责任。"
  },
  {
    "type": "p",
    "text": "14.8 用户在圆领平台的论坛、社区以及云市场上自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、 联系人及联络信息，相关图片、资讯等，均由用户自行提供，用户须对其提供的前述信息依法承担全部责任。"
  },
  {
    "type": "p",
    "text": "14.9 如果用户通过使用本平台或获取来自第三方的任何产品或服务，例如，圆领平台云市场上的服务商依托云市场向您提供服务，服务商将对其提供的服务向您负责，圆领平台对此第三方服务不承担任何责任。"
  },
  {
    "type": "p",
    "text": "14.10 在某些情况下，为了帮助用户更便捷的使用圆领平台的服务，圆领平台可能会展示圆领平台的参考代码或软件（如属于第三方开源软件，用户则应遵守第三方开源软件的相关使用要求），基于相应展示页面的使用说明，该等软件可能允许用户予以下载、进行二次开发等相关操作，用户应理解并承诺，该等代码的知识产权属于圆领平台，用户在使用时应明确表明权利人，同时，圆领平台不对用户能否使用以及使用该等代码、软件的服务和后果负责。"
  },
  {
    "type": "h2",
    "text": "15 管辖、法律适用与争议解决"
  },
  {
    "type": "p",
    "text": "15.1 本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用的有效法律（但不包括其冲突法规则）。如发生本协议与适用的法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。"
  },
  {
    "type": "p",
    "text": "15.2 因本协议履行过程中，因用户使用本平台服务产生争议应由平台与平台用户沟通并协商处理。协商不成时，双方均同意以魔法向量住所地人民法院为管辖法院。"
  },
  {
    "type": "h2",
    "text": "16 其他"
  },
  {
    "type": "p",
    "text": "16.1 本协议包含了用户使用圆领网站与应用程序需遵守的一般性规范，用户在使用某个平台产品时还需遵守适用于该产品的特殊性规范。一般性规范如与特殊性规范不一致或有冲突，则特殊性规范具有优先效力。"
  },
  {
    "type": "p",
    "text": "16.2 本协议由本协议的内容、网站相关页面上展现的规则、规范，服务说明（含操作文档）和用户点击确认的其他条款/条件组成，圆领平台和用户均受其约束，且其中的相关名词可相互引用、解释。"
  },
  {
    "type": "p",
    "text": "16.3 本服务条款的章节标题仅为行文方便而设，不具有法律或合同效力。"
  },
  {
    "type": "p",
    "text": "16.4 本平台有权在圆领官网（www.yuanling.com）上发布公告、发站内通知或邮件通知等方式将本服务的权利义务全部或者部分转移给圆领平台的关联公司。除另有约定外，出于服务专业性考虑，圆领平台亦可能委托关联公司或其他法律主体向用户提供圆领平台上一项或多项具体服务，同时用户可能会与该等公司订立相关条款或条件，请用户审慎阅读、充分理解条款和条件内容，选择接受或不接受该条款和条件。"
  },
  {
    "type": "p",
    "text": "16.5 用户理解并同意，本平台可通过网页公告、电子邮件、站内信、短信、电话、系统消息以及即时通信等以上一种或多种通知方式向用户发送通知，且本平台可以信赖用户所提供的联系信息是完整、准确且当前有效的；上述通知在发送成功后视为已送达。"
  },
  {
    "type": "p",
    "text": "16.6 除非本协议另有约定或本平台与用户另行签订的协议明确规定了通知方式，用户发送给本平台的通知，应当通过本平台对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。"
  },
  {
    "type": "p",
    "text": "16.7 本协议终止或失效不影响协议项下的保密条款、知识产权条款、法律适用及争议解决条款的效力。"
  },
  {
    "type": "p",
    "text": "16.8 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。"
  },
  {
    "type": "br"
  },
  {
    "type": "h1",
    "text": "圆领平台账户注销重要提醒"
  },
  {
    "type": "p",
    "text": "您将无法再次使用该账户登录圆领平台以及其他使用该账户登录的网站及客户端，包括但不限于圆领网（域名为 yuanling.com）、圆领APP等进行任何操作；"
  },
  {
    "type": "p",
    "text": "您的账户名称将被释放，供其他用户进行注册；"
  },
  {
    "type": "p",
    "text": "您的账户内所有历史记录信息将被清除并无法再次找回；"
  },
  {
    "type": "p",
    "text": "您的账户内所获得的任何优惠信息（平台积分、平台优惠券、平台红包等）都将作废。"
  },
  {
    "type": "p",
    "text": "6.特别地，如果您的圆领平台账户在连续6个月内没有任何操作行为，且满足其他圆领平台账户注销条件时，圆领平台有权依照适用的法律和《圆领平台用户协议》主动进行注销。"
  },
  {
    "type": "p",
    "text": "8.本通知未尽事宜，圆领平台依照与您约定的《圆领平台用户协议》执行。"
  },
  {
    "type": "p",
    "text": "本协议条款解释权归本平台所有。"
  },
  {
    "type": "br"
  },
  {
    "type": "br"
  },
  {
    "type": "br"
  }
];
